import { Box, Grid, Typography } from "@mui/material";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "../ProductDetails/styles.css";
import { Star } from "@mui/icons-material";
import moment from "moment";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import ImageUploader from "../EditProduct/ImageUploader";
const AddProductImage = () => {
  const location = useLocation();
  const [selectedColor, setSelectedColor] = useState("");

  const product = location?.state?.product;
  const currentColorData = product?.colors.find(c => c.colorCode === selectedColor);
  const handleColorChange = color => {
    setSelectedColor(color);
  };
  useEffect(() => {
    // if (product) setSelectedColor(product?.colors[0]?.colorCode);
    const activeColor = product?.colors?.find(color => color.isActive);
    if (activeColor) {
      setSelectedColor(activeColor.colorCode);
    }
  }, [product]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box py={2}>
        <Typography variant='h5' gutterBottom>
          Add Product Image
        </Typography>
        <Grid container spacing={4}>
          <Grid style={{ height: "500px", position: "sticky", top: "90px" }} item xs={12} md={4}>
            <ImageUploader />
            {/* {currentColorData?.images?.length > 0 && (
              <Swiper
                style={{
                  "--swiper-navigation-color": "#fff",
                  "--swiper-pagination-color": "#fff",
                  borderRadius: "10px",
                }}
                loop={true}
                spaceBetween={10}
                // navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Thumbs]}
                className='mySwiper2'
              >
                {currentColorData?.images.map((e, i) => (
                  <SwiperSlide>
                    <img src={e?.image} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {currentColorData?.images?.length > 0 && (
              <Swiper
                onSwiper={setThumbsSwiper}
                loop={true}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className='mySwiper'
              >
                {currentColorData?.images.map((e, i) => (
                  <SwiperSlide>
                    <img src={e?.image} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )} */}
            {currentColorData?.images == 0 && (
              <div onClick={() => navigate("/add-product-image", { state: { product: product } })}>
                add image
              </div>
            )}
          </Grid>

          {/* Product Information Section */}
          <Grid item xs={12} md={8}>
            {/* <Typography sx={{ padding: "10px 0", fontSize: "16px", fontWeight: "500" }}>
              Product short description
            </Typography>
            <Typography sx={{ marginBottom: "16px", fontSize: "16px" }}>
              Nec ultrices dui sapien eget. Duis ut diam quam nulla porttitor massa id neque
              aliquam.
            </Typography> */}

            {/* <Grid
              container
              spacing={2}
              sx={{
                marginBottom: "16px",
                marginTop: "16px",
                padding: "12px",
                border: "1px solid #EBF0ED",
                background: "#FAFAFA",
                borderRadius: "16px",
              }}
            >
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  ₴{product?.price}
                </Typography>
                <Typography variant='caption'>Price</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  {product?.rating}
                </Typography>
                <Typography variant='caption'>Rating</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  ---
                </Typography>
                <Typography variant='caption'>Available Stocks</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  ---
                </Typography>
                <Typography variant='caption'>Review Count</Typography>
              </Grid>
            </Grid> */}

            {/* Sizes */}
            {/* <Typography variant='h6'>Sizes:</Typography>
            <Box sx={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
              {["XS", "S", "M"].map(size => (
                <Chip key={size} label={size} variant='outlined' />
              ))}
            </Box> */}

            {/* Colors */}
            <Typography variant='h6'>Colors:</Typography>
            <Box sx={{ display: "flex", gap: "8px", marginBottom: "16px", alignItems: "center" }}>
              {product?.colors.map(color =>
                color?.isActive ? (
                  <Box
                    key={color.productColorId}
                    onClick={() => handleColorChange(color.colorCode)}
                    sx={{
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: `1px solid ${color?.colorCode}`,
                      backgroundColor: `${selectedColor == color?.colorCode}`,
                      width: `${selectedColor == color.colorCode ? "32px" : "24px"}`,
                      height: `${selectedColor == color.colorCode ? "32px" : "24px"}`,
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: `${color?.colorCode}`,
                        width: "24px",
                        height: "24px",
                        display: "inline-block",
                        borderRadius: "4px",
                      }}
                    ></span>
                  </Box>
                ) : (
                  ""
                )
              )}
            </Box>
            {/* Description */}
            {/* <Typography variant='h6' sx={{ fontWeight: "bold", marginBottom: "8px" }}>
              Product Description
            </Typography>
            <Typography variant='body2' sx={{ color: "gray" }}>
              Vestibulum tristique sollicitudin nibh sit amet. Semper tristique sollicitudin nibh
              sit amet.
            </Typography> */}

            {/* Additional Information */}
            {/* <Typography variant='h6' sx={{ fontWeight: "bold", marginTop: "24px" }}>
              Additional Information
            </Typography>
            <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
              <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                Warranty
              </Typography>
              <div style={{ display: "flex", gap: "40px", padding: "5px" }}>
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>Hindi</div>
                  {product?.warranty?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e.descriptionUz}
                    </Typography>
                  ))}
                </div>
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                  {product?.warranty?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e.descriptionEn}
                    </Typography>
                  ))}
                </div>
              </div>
            </Box>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Characteristics
                  </Typography>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>Hindi</div>
                  {product?.characteristics?.map(e => (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e.valueUz}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e.keyUz}
                      </Typography>
                    </div>
                  ))}
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                  {product?.characteristics?.map(e => (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e.valueUz}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e.keyUz}
                      </Typography>
                    </div>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Descriptions
                  </Typography>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>Hindi</div>
                  {product?.descriptions?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e.descriptionUz}
                    </Typography>
                  ))}
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>English</div>
                  {product?.descriptions?.map(e => (
                    <Typography style={{ fontSize: "12px", color: "gray" }}>
                      {e.descriptionEn}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Ratings & Reviews
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "green",
                        borderRadius: "6px",
                        fontSize: "16px",
                        color: "white",
                        padding: "4px 20px",
                      }}
                    >
                      {product?.rating}
                    </div>
                    <div>
                      {[1, 2, 3, 4].map(e => (
                        <Star sx={{ color: "gold", padding: 0, width: "12px", height: "14px" }} />
                      ))}
                      <div style={{ fontSize: "12px", marginTop: "-10px" }}>
                        Based on 5,438 Ratings
                      </div>
                    </div>
                  </Box>
                  {[5, 4, 3, 2, 1].map(star => (
                    <Box
                      key={star}
                      sx={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}
                    >
                      <Typography style={{ fontSize: "12px" }}>{star} Stars</Typography>
                      <Box
                        sx={{
                          flexGrow: 1,
                          height: "8px",
                          backgroundColor: "#ddd",
                          position: "relative",
                        }}
                      >
                        <Box
                          sx={{
                            width: `${star * 20}%`,
                            backgroundColor: star === 5 ? "green" : star === 4 ? "blue" : "orange",
                            height: "100%",
                            borderRadius: "12px",
                          }}
                        ></Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Reviews {product?.productReview > 0 ? product?.productReview?.length : ""}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        boxShadow: "0 0 4px 1px rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        padding: "5px 10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "8px" }}>
                          <Typography variant='subtitle1' style={{ fontSize: "14px" }}>
                            Aidan Keebler
                          </Typography>
                        </Box>
                        <Typography variant='caption'>
                          {moment(product?.createdAt).format("DD/MM/YYYY")}
                        </Typography>
                      </Box>
                      <Typography variant='body2' sx={{ fontSize: "12px" }}>
                        Corrupit praesentium sint nisi molestiae harum odit.
                      </Typography>
                    </div>
                    <div
                      style={{
                        boxShadow: "0 0 4px 1px rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        padding: "5px 10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "8px" }}>
                          <Typography variant='subtitle1' style={{ fontSize: "14px" }}>
                            Aidan Keebler
                          </Typography>
                        </Box>
                        <Typography variant='caption'>
                          {moment(product?.createdAt).format("DD/MM/YYYY")}
                        </Typography>
                      </Box>
                      <Typography variant='body2' sx={{ marginTop: "4px", fontSize: "12px" }}>
                        Corrupit praesentium sint nisi molestiae harum odit.
                      </Typography>
                    </div>
                  </div>
                </Box>
              </Grid>
            </div> */}
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </DashboardLayout>
  );
};

export default AddProductImage;
